import { lazy } from "react"
import type { FC, LazyExoticComponent, ReactElement } from "react"

import { ETypographyAlignment, ETypographySize, Loadable, RootLoaderFallback, Typography } from "@/3514/components"
import { type TDiagnosticSummaryEntityProps, diagnosticSummaryEntityLoader } from "@/3514/entities/diagnostic-summary"
import { EUserRole } from "@/3514/types"
import { type IUseTranslation, useTranslation } from "@/hooks"

import classes from "./coach.individual-participant.styles"
import { type TCoachIndividualParticipantSharedTabProps as TSharedProps } from "./coach.individual-participant.ui.types"

const LazyDiagnosticsEntity: LazyExoticComponent<FC<TDiagnosticSummaryEntityProps>> =
    lazy(diagnosticSummaryEntityLoader)

type _TProps = TSharedProps & { isParticipantLoading: boolean; isDiagnosticEnabled: boolean }
const CoachIndividualParticipantDiagnosticTab: FC<_TProps> = ({
    participantId,
    isParticipantLoading,
    isDiagnosticEnabled
}: _TProps): ReactElement => {
    const { t }: IUseTranslation = useTranslation()

    return isParticipantLoading ? (
        <RootLoaderFallback top="25%" xsTop="45%" />
    ) : isDiagnosticEnabled ? (
        <Loadable<TDiagnosticSummaryEntityProps>
            isLoading={isParticipantLoading}
            loadingFallback={<RootLoaderFallback top="25%" xsTop="45%" />}
            component={LazyDiagnosticsEntity}
            componentProps={{
                participantId,
                mode: EUserRole.Coach,
                wrapperClassName: classes.diagnosticTab.container()
            }}
        />
    ) : (
        <div className={classes.diagnosticTab.container()}>
            <Typography
                text={t("coachSide.participantPages.diagnostic.na")}
                className={classes.diagnosticTab.emptyHint()}
                isPretty
                size={ETypographySize.Small}
                alignment={ETypographyAlignment.Left}
            />
        </div>
    )
}

CoachIndividualParticipantDiagnosticTab.displayName = "CoachIndividualParticipantDiagnosticTab"

export default CoachIndividualParticipantDiagnosticTab
